module.exports = __webpack_public_path__ + "static/media/ic_user_report.6d3fd598.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ic_user_report.svg
// module id = 157
// module chunks = 0